import {PewComponent} from "../../../assets/raw/js/components/pew-component";

export class CardComponent extends PewComponent {

  init() {
    this.registerTouchHover();
  }

  registerTouchHover() {
    this.element.on('click', (e) => {
      if ("ontouchstart" in document.documentElement) {
        this.element.toggleClass('hover');
      }
    });
  }

}

window.pew.addRegistryEntry({key: 'card-component', domSelector: '.items-list .item', classDef: CardComponent});



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Card/CardComponent.js